/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/AzureRMAutoServicePrincipalEndpointEditorComponent" />
import * as React from "react";
import * as EndpointConstants from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import { ServiceEndpoint, AccessTokenRequestType } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { AzureRMKeys } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/AzureRMEndpointConstants";
import { AzurRMAutomaticComponent } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/AzureRMAutomaticComponent";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { AzureRMActionCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Actions/AzureRMActionCreator";
import { GenericFooterComponent } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/GenericEndpointComponents/GenericFooterComponent";
import { IEndpointEditorComponentProps } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { EndpointDetailsComponent } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/KubernetesEndpoint/Components/EndpointDetailsComponent";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { Observer } from "VSSUI/Observer";
import { ObservableValue } from "VSS/Core/Observable";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { IVssPageContext } from "VSS/Platform/Context";
import { Link } from "VSSUI/Link";
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { ServiceEndpointsSource } from "DistributedTaskUI/ServiceEndpoints/Editor/Source/ServiceEndpointsSource";
import { ServiceEndpointRequest, ServiceEndpointRequestResult } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { AzureRMPublishProfileComponent } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/AzureRMPublishProfileComponent";
import * as Utils_Accessibility from "VSS/Core/Util/Accessibility";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

export interface IAzurRMComponentProps extends IEndpointEditorComponentProps {
    hidePanelFooter: (hideFooter: boolean) => void;
    closePanel: (serviceEndpoint: ServiceEndpoint) => void;
    onRefresh: () => void;
    onBackButtonClick: () => void;
    hideBackButton: boolean;
    isVerifiableConnection: boolean;
    updateError: (isError: boolean, errorMessage: string, errorStatus?: string, activityId?: string) => void;
    getInvalidInputCount: () => number;
    errorMessage: string;
}

export interface IAzurRMComponentState {
    saveInProgress: boolean;
    setupInProgress: boolean;
    isError: boolean;
    errorMessage: string;
    activityId?: string;
    isVerifyInProgress: boolean;
    isVerificationSuccess: boolean;
}

export class AzureRMAutoServicePrincipalEndpointEditorComponent extends VssComponent<IAzurRMComponentProps, IAzurRMComponentState> {

    constructor(props: IAzurRMComponentProps, context: IVssComponentContext) {
        super(props, context);

        this._source = ServiceEndpointsSource.getInstance(context.pageContext);
        this._draftServiceEndpoint = props.draftEndpoint;
        this._draftServiceEndpoint.data = this._draftServiceEndpoint.data || {};
        this._draftServiceEndpoint.authorization.parameters = this._draftServiceEndpoint.authorization.parameters || {};
        if (this._draftServiceEndpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.PublishProfile) {
            this._actionCreatorKey = AzureRMKeys.PUBLISH_PROFILE_INSTANCE_KEY;
        }
        this._actionCreator = ActionCreatorManager.CreateActionCreator<AzureRMActionCreator, IVssPageContext>(AzureRMActionCreator, this._actionCreatorKey, context.pageContext);

        this._endpointEditorActionCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(EndpointsEditorActionsCreator, ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId);
        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        this._endpointEditorStore.addChangedListener(this._onEndpointEditorStoreChange);

        this._reloadFooter = new ObservableValue(false);
        this._isSaveEnabled = props.isUpdateForm;
        this._invalidComponentCount = 0;
        this._isEndpointDetailsComponentValid = props.isUpdateForm;
        this.props.hidePanelFooter(true);
        this.state = {
                    saveInProgress: false,
                    setupInProgress: false,
                    isError: false,
                    errorMessage: "",
                    isVerifyInProgress: false,
                    isVerificationSuccess: undefined
        };

        this.setTimeout(() => {
            this.props.updateDraftEndpointState(this._draftServiceEndpoint);
        });
    }

    public componentWillUnmount() {
        ActionCreatorManager.DeleteActionCreator(AzureRMActionCreator, this._actionCreatorKey);
        this._endpointEditorStore.removeChangedListener(this._onEndpointEditorStoreChange);
    }

    public componentWillReceiveProps(nextProps: IAzurRMComponentProps){
        this._draftServiceEndpoint = nextProps.draftEndpoint;
    }

    public render(): React.ReactNode {
        let azureRmComponent = this._getAzureRMComponentByAuthScheme();
        return (
            <React.Fragment>
                <div>
                    { azureRmComponent }
                    { this.props.isUpdateForm && this._draftServiceEndpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.ServicePrincipal &&
                    this._draftServiceEndpoint.data.creationMode === EndpointConstants.AzureEndpointConstants.SpnCreationModeAutomatic && this._getVerificationComponent() }
                    <EndpointDetailsComponent
                        {...this.props}
                        draftEndpoint={this._draftServiceEndpoint}
                        isUpdateForm={this.props.isUpdateForm}
                        updateValidAndDirtyStateChange={this._handleValidAndDirtyStateChangeForEndpointDetails}
                        instanceId={"EndpointDetailsComponent"}
                        updateAllowAllPipelinesFlag={this.props.updateAllowAllPipelinesFlag}
                        allowAllPipelinesFlagState={this.props.allowAllPipelinesFlagState}
                    />
                </div>
                { this.state.isError && <MessageCard
                    className="flex-self-stretch  margin-top-16 margin-bottom-16"
                    severity={MessageCardSeverity.Error}
                   >
                   {this.state.errorMessage}
                   <br />
                   {this.state.activityId ? "ActivityId: " + this.state.activityId : null}
                   <div>
                        <span>{Resources.WorkloadIdentityFederationManualCreationSuggestion}</span>&nbsp;
                        <Link target="_blank" href={"https://aka.ms/azdo-rm-workload-identity-manual"}>{Resources.LearnMoreText}</Link>
                    </div>
                </MessageCard>}
                {this._getFooterComponent()}
            </React.Fragment>
        );
    }

    private _removeDuplicateKeysFromRequest()
    {
        let actualParameters = this._draftServiceEndpoint.authorization.parameters;
        let counts = Object.create(null);
        let tempParameters: any = {};
        let hasDuplicates = false;

        for (let key in actualParameters){
            let lowKey = key.toLowerCase();
            counts[lowKey] = counts[lowKey] ? counts[lowKey] + 1 : 1;
            if (counts[lowKey] > 1) {
                hasDuplicates = true;
                tempParameters[lowKey] = null;
            }
        }
        if (hasDuplicates) {
            for (let key in actualParameters) {
                let lowKey = key.toLowerCase();
                if (counts[lowKey] === 1) {
                    tempParameters[key] = actualParameters[key];
                }
                else {
                    let value = actualParameters[key];
                    if (value !== null && value !== undefined) {
                        tempParameters[lowKey] = (!tempParameters[lowKey] ? value : tempParameters[lowKey]);
                    }
                }
            }
        }

        this._draftServiceEndpoint.authorization.parameters = hasDuplicates ? tempParameters : actualParameters;
    }
    private _getAzureRMComponentByAuthScheme() {
        if (this._draftServiceEndpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.PublishProfile) {
            return <AzureRMPublishProfileComponent
                {...this.props}
                updateValidAndDirtyState={this._handleValidAndDirtyStateChange}
                updateInvalidComponentCount={this._updateInvalidComponentCount}
            />;
        } else if (this._draftServiceEndpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.ServicePrincipal
            && this._draftServiceEndpoint.data.creationMode === EndpointConstants.AzureEndpointConstants.SpnCreationModeAutomatic) {
            return <AzurRMAutomaticComponent
                {...this.props}
                updateValidAndDirtyState={this._handleValidAndDirtyStateChange}
                updateInvalidComponentCount={this._updateInvalidComponentCount}
            />;
        } else if (this._draftServiceEndpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.WorkloadIdentityFederation
            && this._draftServiceEndpoint.data.creationMode === EndpointConstants.AzureEndpointConstants.SpnCreationModeAutomatic) {
            return <AzurRMAutomaticComponent
                {...this.props}
                updateValidAndDirtyState={this._handleValidAndDirtyStateChange}
                updateInvalidComponentCount={this._updateInvalidComponentCount}
            />;
        }
    }

    private _getVerificationComponent(): React.ReactNode {
        if (this.props.isVerifiableConnection) {
            const isVerificationDisabled: boolean = this.state && this.state.isVerifyInProgress;
            return (
                <div className={"flex-row default-input-margin-top"}>
                    { EndpointsEditorPanelUtils.getVerifyButton(isVerificationDisabled, this._verifyEndpoint) }
                    { this.state && EndpointsEditorPanelUtils.getVerificationDetails(this.state.isVerifyInProgress, this.state.isVerificationSuccess, this.props.errorMessage) }
                </div>
            );
        } else {
            return null;
        }
    }

    private _verifyEndpoint = (): void => {
        this._updateVerificationStatus(true, undefined);
        this._verifyConnection().then((serviceEndpointRequestResult: ServiceEndpointRequestResult) => {
            if (serviceEndpointRequestResult.errorMessage) {
                this._updateVerificationStatus(false, false);
                this.props.updateError(true, serviceEndpointRequestResult.errorMessage, Resources.VerificationFailed, serviceEndpointRequestResult.activityId);
            } else {
                this._updateVerificationStatus(false, true);
                this.props.updateError(false, "");
            }
        }).catch((error) => {
            this._updateVerificationStatus(false, false);
            const errorMessage: string = error.message ? error.message : Resources.ValidateEndpointErrorMessage;
            this.props.updateError(true, errorMessage, Resources.VerificationFailed);
        });
    }

    private _updateVerificationStatus = (isVerifyInProgress: boolean, isVerificationSuccess: boolean): void => {
        this.setState({
            isVerifyInProgress: isVerifyInProgress,
            isVerificationSuccess: isVerificationSuccess
        });
    }

    private _verifyConnection(): Promise<ServiceEndpointRequestResult> {
        const serviceEndpointRequest: ServiceEndpointRequest = EndpointsEditorPanelUtils.getServiceEndpointRequestForTest(this.props.draftEndpoint);
        return this._source.verifyServiceEndpoint(serviceEndpointRequest, this.props.draftEndpoint.id);
    }

    private _getFooterComponent(): React.ReactNode {
        this._isSaveEnabled = this._invalidComponentCount === 0 && this._isEndpointDetailsComponentValid;
        return (
            <Observer reloadFooter={this._reloadFooter}>
                {(props: { reloadFooter: boolean }) => {
                    return (
                        <GenericFooterComponent
                            isUpdateForm={this.props.isUpdateForm}
                            enableSave={this._isSaveEnabled}
                            serviceEndpoint={this._draftServiceEndpoint}
                            showSaveButton={true}
                            showBackButton={!this.props.hideBackButton}
                            saveInProgress={this.state.saveInProgress}
                            setupInProgress={this.state.setupInProgress}
                            onSaveButtonClick={this._saveServiceEndpoint}
                            onBackButtonClick={this.props.onBackButtonClick}
                        />
                    );
                }}
            </Observer>
        );
    }

    private _onEndpointEditorStoreChange = () => {
        const storeState = this._endpointEditorStore.getState();

        if (this.state.saveInProgress && !storeState.setupInProgress && !storeState.saveInProgress && !storeState.errorMessage) {
            setTimeout(() => {
                this.props.closePanel(storeState.serviceEndpoint);
            });
        }

        if (this.state.setupInProgress && !storeState.setupInProgress && !storeState.errorMessage) {
            setTimeout(() => {
                this.props.closePanel(storeState.serviceEndpoint);
            });
        }

        this.setState({
            saveInProgress: storeState.saveInProgress,
            setupInProgress: storeState.setupInProgress,
            isError: storeState.isError,
            errorMessage: storeState.errorMessage,
            activityId: storeState.activityId
        });
    }

    private _updateInvalidComponentCount = (invalidComponentCount: number) => {
        this._invalidComponentCount = invalidComponentCount;
        const isSaveable = this._invalidComponentCount === 0 && this._isEndpointDetailsComponentValid;

        if (isSaveable !== this._isSaveEnabled) {
            this._isSaveEnabled = isSaveable;
            this._reloadFooterBar();
        }
    }

    private _handleValidAndDirtyStateChange = (isValid?: boolean) => {
        if (isValid !== undefined) {
            this._invalidComponentCount += isValid ? -1 : 1;
        }
        const isSaveable = this._invalidComponentCount === 0 && this._isEndpointDetailsComponentValid;

        if (isSaveable !== this._isSaveEnabled) {
            this._isSaveEnabled = isSaveable;
            this._reloadFooterBar();
        }
    }

    private _handleValidAndDirtyStateChangeForEndpointDetails = (isValid?: boolean) => {
        if (isValid !== undefined) {
            this._isEndpointDetailsComponentValid = isValid;
        }

        const isSaveable = this._invalidComponentCount === 0 && this._isEndpointDetailsComponentValid;

        if (isSaveable !== this._isSaveEnabled) {
            this._isSaveEnabled = isSaveable;
            this._reloadFooterBar();
        }
    }

    private _saveServiceEndpoint = () => {
        const azureSubscriptionTenantId = this._draftServiceEndpoint.authorization.parameters.tenantid;
        this._actionCreator.getAccessTokenAsync(azureSubscriptionTenantId).then((accessToken) => {
            if (accessToken && this._draftServiceEndpoint.authorization.scheme !== EndpointConstants.EndpointAuthorizationSchemes.PublishProfile
                && this._draftServiceEndpoint.data.creationMode === EndpointConstants.AzureEndpointConstants.SpnCreationModeAutomatic
                && (this._draftServiceEndpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.ServicePrincipal || this._draftServiceEndpoint.authorization.scheme === EndpointConstants.EndpointAuthorizationSchemes.WorkloadIdentityFederation)) {
                this._draftServiceEndpoint.authorization.parameters.accessTokenFetchingMethod = AccessTokenRequestType.Oauth.toString();
                this._draftServiceEndpoint.authorization.parameters.accessToken = accessToken;
            }
            this._removeDuplicateKeysFromRequest();
            this._endpointEditorActionCreator.customSaveServiceEndpoint(this._draftServiceEndpoint, this.props.allowAllPipelinesFlagState, this.props.isUpdateForm);
        }, error => {
            if (error.message) {
                Utils_Accessibility.announce(error.message);
            }
            this.setState({ errorMessage: error });
        });
    }

    private _reloadFooterBar() {
        this._reloadFooter.value = !this._reloadFooter.value;
    }

    private _draftServiceEndpoint: ServiceEndpoint;
    private _actionCreator: AzureRMActionCreator;
    private _endpointEditorActionCreator: EndpointsEditorActionsCreator;
    private _endpointEditorStore: EndpointsEditorStore;
    private _isSaveEnabled: boolean;
    private _reloadFooter: ObservableValue<boolean>;
    private _invalidComponentCount: number;
    private _isEndpointDetailsComponentValid: boolean = false;
    private _actionCreatorKey = AzureRMKeys.AZURERM_INSTANCE_KEY;
    private _source: ServiceEndpointsSource;
}